import styles from "./delete-confirmation-modal-view.module.scss";
import { Button } from "@/components/buttons/button";

type DeleteConfirmationModalViewProps = {
  name: string;
  onCancel: () => void;
  onDelete: () => void;
  isDeleteLoading?: boolean;
};

export const DeleteConfirmationModalView = ({
  name,
  onCancel,
  onDelete,
  isDeleteLoading,
}: DeleteConfirmationModalViewProps) => (
  <>
    <h2 className={styles.modalContentHeader}>{`Delete ${name}?`}</h2>
    <p className={styles.deleteConfirmationDescription}>
      {"Warning, this action cannot be undone!"}
    </p>
    <div className={styles.deleteConfirmationButtons}>
      <Button
        onClick={onDelete}
        variant="primary"
        size="medium"
        tone="destructive"
        text="brand"
        isFullWidth
        disabled={isDeleteLoading}
        loading={isDeleteLoading}
      >
        {"Delete"}
      </Button>
      <Button
        onClick={onCancel}
        variant="secondary"
        size="medium"
        text="brand"
        isFullWidth
        disabled={isDeleteLoading}
      >
        {"Don’t delete"}
      </Button>
    </div>
  </>
);
